import React from 'react';

const address = 'support@nemedio.com';

function ContactSupport(props) {
  return <a href={`mailto:${address}`}>{props.children ? props.children : address}</a>;
}

export default ContactSupport;
